import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { clarity } from "react-microsoft-clarity";
import { GoogleAnalyticsProvider } from "./providers/GoogleAnalyticsProvider";
import { ScrollToTop } from "./utilities/ScrollToTop";

// Lazy-load each page so only the current route's JS is fetched
const Layout = lazy(() =>
  import("./pages/Layout").then((m) => ({ default: m.Layout }))
);
const Home = lazy(() =>
  import("./pages/Home").then((m) => ({ default: m.Home }))
);
const PrivacyPolicy = lazy(() =>
  import("./pages/PrivacyPolicy").then((m) => ({ default: m.PrivacyPolicy }))
);
const Contact = lazy(() => import("./pages/Contact"));

// Minimal full-screen loader shown while a route chunk loads
const PageLoader: React.FC = () => (
  <div
    style={{
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "var(--cream)",
    }}
    aria-label="Loading page"
    role="status"
  >
    <div
      style={{
        width: 40,
        height: 40,
        borderRadius: "50%",
        border: "3px solid var(--caramel-soft)",
        borderTopColor: "var(--orange)",
        animation: "spin .7s linear infinite",
      }}
    />
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
  </div>
);

const App = () => {
  clarity?.init("oewkvmnrit");

  if (clarity?.hasStarted()) {
    clarity?.identify("USER_ID", { userProperty: "value" });
  }

  return (
    <Router>
      <ScrollToTop>
        <GoogleAnalyticsProvider>
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<Layout />}>
                <Route index element={<Home />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
            </Routes>
          </Suspense>
        </GoogleAnalyticsProvider>
      </ScrollToTop>
    </Router>
  );
};

export default App;
